import { useContext, useMemo } from "react";
import { ZipProjectActionsEnum } from "@app/projects/zip-projects/interfaces";
import { ZipProjectContext } from "@app/projects/zip-projects/ZipProjectContext";
import { ProjectRunConfigurationType } from "@app/projects/enumerators";
import { WafflesPaginationProps } from "@app/shared/waffles/exports";

interface UseZipProjectPaginationPropsReturn {
  calculatedTotalNumberOfRecords: number;
  paginationProps: WafflesPaginationProps;
}

export const useZipProjectPaginationProps = (): UseZipProjectPaginationPropsReturn => {
  const projectContext = useContext(ZipProjectContext);
  const { state, dispatch } = projectContext;

  const changePage = (newPage: number) => {
    const newSkip = (newPage - 1) * state.take;
    dispatch({
      payload: { loading: true },
      type: ZipProjectActionsEnum.Loading,
    });
    projectContext.onChangeTablePage(newSkip);
  }

  const calculatedTotalNumberOfRecords = useMemo(() => {
    // typeof undefined and null are undefined and object, respectively
    if (state.isDualMembershipMode && typeof state.totalNumberOfRecords === "number" && typeof state.totalNumberOfRecordsSecondary === "number") {
      return Math.max(state.totalNumberOfRecords, state.totalNumberOfRecordsSecondary);
    } else if (state.runConfiguration.projectRunConfigurationType === ProjectRunConfigurationType.DualMembershipSupplemental) {
      return state.totalNumberOfRecordsSecondary;
    }
    return state.totalNumberOfRecords;
  }, [state.runConfiguration, state.isDualMembershipMode, state.filterSelections, state.totalNumberOfRecords, state.totalNumberOfRecordsSecondary]);

  const paginationProps: WafflesPaginationProps = {
    changePage: changePage,
    recordsPerPage: state.take,
    skip: state.skip,
    totalRecords: calculatedTotalNumberOfRecords,
  }

  return { calculatedTotalNumberOfRecords, paginationProps };
}
